import { Box, IconButton, Modal, Typography } from '@mui/material';
import './styles.scss'
import Grid from "@mui/material/Grid2";
import { Scatter } from 'react-chartjs-2';
import CloseIcon from '@mui/icons-material/Close';
import { Dyn, DynSort } from './sort_dyn';
import { useEffect, useState } from 'react';


export const ModalDyn = ({ listSortDyns, open, onClose, onChangeDyn }: { listSortDyns: DynSort[], open: any, onClose: any, onChangeDyn: any }) => {

    const [listSortDynsSortByDates, setListSortDynsSortByDates] = useState<DynSort[]>([])

    useEffect(() => {
        const listSortDynsSortByDates = listSortDyns.sort((a, b) => new Date(b.executedDate).getTime() - new Date(a.executedDate).getTime())
        setListSortDynsSortByDates(listSortDynsSortByDates)
    }, [listSortDyns])
    

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
        },
        scales: {
            x: { display: false },
            y: { display: false }
        },
        elements: {
            point: {
                pointStyle: 'circle',
                radius: 1,
                borderColor: 'rgb(146, 147, 149)',
            }
        }
    }

    return (
        <Modal
            open={open}
            onClose={() => onClose()}
        >
            <Box className="modal_update_card_location">
                {/* headers */}
                <Box className="modal_header"  
                    sx={{ 
                        position: "sticky", top: 0, 
                        zIndex: 10, display: "flex", 
                        justifyContent: "space-between", alignItems: "center", 
                        padding: "15px" }}>
                    <IconButton
                        aria-label="delete"
                        size='small'
                        onClick={() => onClose()}
                    >
                        <CloseIcon color="error" />
                    </IconButton>
                    <Typography className='title' id="modal-modal-title" variant="h6" component="h2">
                        Dyn
                    </Typography>
                    <Grid>

                    </Grid>
                </Box>
                <Box sx={{ p: 2, gap: 2 }} >
                    <Box className="table_card_container">
                        {/* tableHeader */}
                        <Grid className="headers">
                            <Grid>Miniatura</Grid>
                            <Grid>Fecha</Grid>
                            <Grid>Max Load</Grid>
                            <Grid>Stroke</Grid>
                            <Grid>Bottom Load</Grid>
                            <Grid>MPT</Grid>
                        </Grid>
                        <Grid className="rows_container">
                            {listSortDynsSortByDates?.map((sortDyn: DynSort, j: number) => (
                                sortDyn?.dyns.map((dyn: Dyn, index: number) => (
                                    <Grid className="row" key={`${sortDyn?.fieldActivityId}-${index}-${j}`} onClick={() => onChangeDyn(sortDyn?.fieldActivityId, index)}>
                                        <Grid sx={{ maxHeight: '90px' }}>
                                            {dyn?.datasetSurface && <Scatter options={options} data={dyn?.datasetBottom||dyn?.datasetSurface} />}
                                        </Grid>
                                        <Grid>{sortDyn?.executedDate}</Grid>
                                        <Grid>{dyn?.surfacePeakLoad?.toFixed(2)}</Grid>
                                        <Grid>{dyn?.strokeLength?.toFixed(2)}</Grid>
                                        <Grid>{dyn?.bottomPeakLoad?.toFixed(2)}</Grid>
                                        <Grid>{dyn?.mpt?.toFixed(2)}</Grid>
                                    </Grid>
                                ))
                            ))}
                        </Grid>

                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}